<template>
  <div>
    <div
      v-on:click="
        $selectOdd({
          id_event: event.id,
          id_odd: odd.id_odd,
          description: event.description,
          data: odd,
          live,
        })
      "
      :class="[
        {
          'transparent grey--text v-card--disabled':
            odd.odd_price < oddMin || odd.active != 1,
          'cursor-pointer oddActive':
            odd.odd_price > oddMin && odd.active === '1',
          colorOddSelectedTheme: oddSelected,
        },
        odd.odd_price > oddMin && odd.active == 1 ? oddClassAni : '',
      ]"
      class="
        odd
        text-center
        py-3
        px-1
        subtitle-2
        d-flex
        flex-grow-0
        justify-center
        align-center
        colorOddText--text
      "
      :style="{
        'min-width': $vuetify.breakpoint.xsOnly ? '50px' : '56px',
        'min-height': $vuetify.breakpoint.xsOnly ? '50px' : '50px',
        margin: $vuetify.breakpoint.xsOnly
          ? '0 0 0 4px !important'
          : '0 4px 0 4px !important',
      }"
    >
      <span
        v-if="odd.odd_price >= oddMin && odd.active == 1"
        :ref="odd.id_odd"
        :class="odd.id_odd"
      >
        {{ roundedOddPrice || "" }}
      </span>
      <!-- <span v-show="odd.odd_price >= oddMin">{{ odd.odd_price_real || '' }}</span> -->
      <!-- <v-icon v-show="odd.odd_price < oddMin || odd.active != 1" color="grey" size="16">mdi-lock</v-icon>          -->

      <!-- <div v-show="odd.odd_price < oddMin || odd.active != 1" class="text--secondary overline">bloq.</div> -->
      <v-icon
        v-show="odd.odd_price < oddMin || odd.active != 1"
        size="14"
        class="text--secondary"
        >mdi-lock</v-icon
      >
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "list-odds",
  props: ["odd", "event", "live"],
  data: () => ({
    oddMin: "",
    oddFirst: "",
    classAni: "",
  }),
  computed: mapState({
    oddSelected: function() {
      return this.$store.getters.confirmOddSelectedById(this.odd.id_odd);
    },
    oddClassAni: function() {
      if (this.$refs[this.odd.id_odd] != undefined) {
        const new_price = Number(this.odd.odd_price).toFixed(2);
        const current_price = Number(
          this.$refs[this.odd.id_odd].innerHTML
        ).toFixed(2);
        let increased = new_price > current_price;
        let decreased = new_price < current_price;
        if (increased) this.classAni = "odd_increased";
        if (decreased) this.classAni = "odd_decreased";

        return this.classAni;
      }
    },
    roundedOddPrice() {
      return new Number(this.odd.odd_price).toFixed(2);
    }
  }),
  mounted() {
    this.oddMin = this.$store.state.operators.odd_min;
  },
  methods: {},
};
</script>
<style lang="css">
.odd {
  border-radius: 5px;
  border: 1px solid rgba(255, 255, 255, 0);
  background-color: rgba(255, 255, 255, 0.15);
  transition: background-color 0.2s ease;
  position: relative;
}
.oddActive:hover {
  background-color: rgba(255, 255, 255, 0.3) !important;
  transition: background-color 0.2s ease;
}

/* .odd_equal::after, */
.odd_increased::before,
.odd_decreased::before,
.odd_increased::after,
.odd_decreased::after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}
.odd_increased::before,
.odd_decreased::after {
  bottom: 3px;
}
.odd_decreased::before,
.odd_increased::after {
  top: 3px;
}
.odd_increased::before {
  border-top: 8px solid rgba(255, 255, 255, 0.1);
}
.odd_increased::after {
  border-bottom: 8px solid #76ff03;
}
.odd_decreased::before {
  border-bottom: 8px solid rgba(255, 255, 255, 0.1);
}
.odd_decreased::after {
  border-top: 8px solid #d32f2f;
}

@keyframes oddAniIncreased {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes oddAniDecreased {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.odd_increased::after {
  animation-name: oddAniIncreased;
}
.odd_decreased::after {
  animation-name: oddAniDecreased;
}
.odd_increased::after,
.odd_decreased::after {
  animation-duration: 0.5s;
  animation-iteration-count: 7;
  animation-direction: alternate forwards;
}
</style>
